$(function () {
    var body = $('body');
    var nav = $('.nav');
    var menu_open = $('.menuOpen');
    var menu_close = $('.menuClose');
    var nav_trigger = $('.nav').find('ul li.menu-item-has-children > button, ul li.menu-item-has-children > a');
    var megamenu_trigger = $('.nav').find('ul li.menu-item-has-megamenu .menu-item-has-megamenu-button>button, ul li.menu-item-has-megamenu .menu-item-has-megamenu-button>a');
    var megamenu_button = $('.nav').find('ul li.menu-item-has-megamenu .menu-item-has-megamenu-button button');
    var megamenu_parent = $(".menu-item-has-megamenu");
    var sidemenu = $(".sidemenu");
    var searchBarElement = $('.sidemenu .searchBarElement');
    var searchBarInput = $('.sidemenu .searchBarFocus');
    var searchBarButton = $('.sidemenu .submit_wrap button');
    var break_point = 992;
    var browser_width = window.innerWidth;
    var nav_window = $('<div class="navwindow"></div>');
    body.append(nav_window);
    var nav_wrap = $('.navwrap');
    var advanced_filters_button = $('.advancedFiltersButton');
    var advanced_filters = $('.advancedFiltersInfo');

    document.addEventListener('keydown', function (event) {
        const key = event.key;
        if (key === "Escape") {
            if (browser_width < break_point) {
                nav_reset();
                sidemenu_reset();
                menu_open.focus();
            } else {
                $('.menu-item-has-children').removeClass('__active');
                $('.menu-item-has-megamenu').removeClass('__active');
                $('.menu-item-has-megamenu button').attr('aria-expanded', false);
                body.removeClass('__blur');
                menu_open.focus();
            }
        }
    });

    nav_window.click(function (event) {
        nav_reset();
        sidemenu_reset();
    });

    //menu_open click
    menu_open.click(function (event) {
        advanced_filters_button.attr('aria-expanded', 'false');
        advanced_filters.removeClass('__active');

        event.preventDefault();
        if (browser_width >= break_point) {
            sidemenu_launch();
            body.addClass('__blur');
        }
        else {
            nav_launch();
        }
    });

    menu_close.click(function (event) {
        event.preventDefault();
        if (browser_width >= break_point) {
            sidemenu_reset();
            body.removeClass('__blur');
        }
        else {
            nav_reset();
        }
    })

    menu_close.keypress(function (event) {
        event.preventDefault();
        if (browser_width >= break_point) {
            sidemenu_reset();
            menu_open.focus();
        }
    })

    /*nav reset*/
    var nav_reset = function nav_reset() {
        menu_open.removeClass('__active').attr('aria-expanded', false);
        nav_window.hide();
        body.removeClass('__blur');
        nav_wrap.removeClass('__active');
        nav_wrap.find('ul, div').removeClass('__active');
        megamenu_parent.removeClass('__active');
    };

    var sidemenu_reset = function nav_reset() {
        menu_open.removeClass('__active').attr('aria-expanded', false);
        nav_window.hide();
        body.removeClass('__blur');
        sidemenu.removeClass('__active').attr('aria-hidden', true);
        sidemenu.find('a, button').attr('tabindex', '-1');
        searchBarElement.attr('aria-hidden', 'true');
        searchBarInput.attr('tabindex', '-1');
        searchBarButton.attr('tabindex', '-1');
    };

    /*nav launch*/
    var nav_launch = function nav_launch() {
        menu_open.addClass('__active').attr('aria-expanded', true);
        nav_window.show();
        body.addClass('__blur');
        nav_wrap.addClass('__active');
    };

    var sidemenu_launch = function nav_launch() {
        menu_open.addClass('__active').attr('aria-expanded', true);
        nav_window.show();
        body.addClass('__blur');
        sidemenu.addClass('__active').attr('aria-hidden', false);
        sidemenu.find('a, button').attr('tabindex', '0');
        searchBarElement.attr('aria-hidden', 'false');
        searchBarInput.focus().attr('tabindex', '0');
        searchBarButton.attr('tabindex', '0');
    };

    
    function initMenu() {
        var browser_width = window.innerWidth;

        // nav dropdown on focus/keyboard navigation
        if (browser_width >= break_point) {
            megamenu_trigger.click(function (event) {                
                if($(this).is('button')) {
                    event.preventDefault();
                    $(this).parent().parent().siblings().removeClass('__active');
                    $(this).parent().parent().siblings().find('.__active').removeClass('__active');
                    $(this).parent().parent().siblings().find('[aria-expanded="true"]').attr('aria-expanded', false);
                    $(this).parent().parent().toggleClass('__active');
                    if($(this).parent().parent().hasClass( '__active' )) {
                        $(this).attr('aria-expanded', true);
                        body.addClass('__blur');
                    } else {
                        $(this).attr('aria-expanded', false);
                        $(this).parent().parent().find('.__active').removeClass('__active');
                        body.removeClass('__blur');
                    }
                }
            });

            $(document).on("click", function (event) {
                if ($(event.target).closest(".nav[aria-label='Primary']").length === 0) {
                    nav.find('.__active').removeClass('__active');
                    nav.find('[aria-expanded="true"]').attr('aria-expanded', false);
                }
            });
        }

        if (browser_width < break_point) {
            body.addClass('__mobile');

            nav_trigger.click(function (event) {
                event.stopPropagation();
                if ($(this).parent().children('ul').length > 0) {
                    $(this).parent().children('ul').addClass('__active');
                    $(this).parent().children('ul').find('li:first-child a, li:first-child button').focus();
                }
            });

            megamenu_button.click(function (event) {
                event.preventDefault();
                event.stopPropagation();
                $(this).parent().parent().toggleClass('__active');
                $(this).parent().parent().children('.menu-item-is-megamenu').toggleClass('__active');
                $(this).parent().siblings('.menu-item-is-megamenu').find('.backto').focus();
                
            });

            // Disable root item link click
            $('.menu-item-has-children > a, .menu-item-has-megamenu .menu-item-has-megamenu-button> a, a.megamenu-link-has-children').click(function (event) {
                event.preventDefault();
            });
        }

        if (browser_width < break_point) {

            nav.find('a, button').attr('tabindex', '-1');
            var back_menu = $('.backto');
            back_menu.click(function (event) {
                event.preventDefault();
                event.stopPropagation();
                $(this).parent('ul, .menu-item-is-megamenu').removeClass('__active');
                $(this).parents('li').parent('ul').addClass('__active');
                $(this).parents('li').children('a').focus();
            });

        } else {
            nav_reset();
            sidemenu_reset();
        }

        $('.megamenuClose').on("click", function (event) {
            nav_reset();
            $(this).closest(megamenu_parent).find('button').focus();
        });
        

        // Touch device check
        const isTouchDevice = () => {
            return window.matchMedia("(pointer: coarse)").matches
        }

        // Create view button for touchscreen devices
        var view_button = $('<li class="viewall"><a href="#">View</a></li>');
        
        // If desktop and touch device, disable link click and add extra view link
        if (browser_width > break_point && isTouchDevice()) {
            nav_trigger.click(function (event) {
                event.stopPropagation();
                if ($(this).children('ul').length > 0) {
                    event.preventDefault();
                }
            });

            nav_ul.prepend(view_button);
        }

        var view_all = $('.viewall');
        view_all.click(function (event) {
            event.stopPropagation();
        });

        var back_menu = $('.backto button');
        back_menu.click(function (event) {
            event.preventDefault();
            event.stopPropagation();
            // $(this).closest('.menu-item-has-megamenu').removeClass('__active');
            $(this).closest('.__active').removeClass('__active');
            if($(this).parent().parent().hasClass("menu-item-is-megamenu")) {
                body.removeClass('__blur');
            }
        });
    }
    
    initMenu();

    $(window).on('resize', function(){
        initMenu();
    });

});